module.exports = __webpack_public_path__ + "fonts/pangMenZhengDaoTitleBody.26875b76.ttf";